// On-device (localStorage-only) lineup save/resume — no backend involved,
// so a saved lineup is private to that browser. Used by both the Original
// and Classic Lineup Builder pages.
export function saveLocalLineup(key, data) {
  try {
    window.localStorage.setItem(key, JSON.stringify({ ...data, savedAt: Date.now() }));
    return true;
  } catch (_e) {
    return false;
  }
}

export function loadLocalLineup(key) {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && Array.isArray(parsed.players) && parsed.players.length ? parsed : null;
  } catch (_e) {
    return null;
  }
}

export function clearLocalLineup(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (_e) {
    /* ignore */
  }
}

export const LINEUP_STORAGE_KEY = "last:lineup_builder:saved";
export const CLASSIC_LINEUP_STORAGE_KEY = "last:classic_lineup_builder:saved";
